import React from 'react';
import {
    Box,
    Grid,
    Typography,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Tooltip } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function MetricCard({ title, chartOptions, avg, p95, avgColor, p95Color, unit, helpText, helpTextColor, tooltipText }) {
    return (
        <Box style={{
            backgroundColor: '#fff',
            borderRadius: 8,
            boxShadow: '0 1px 4px rgba(0,0,0,0.10)',
            padding: '6px 12px',
            marginBottom: 5,
        }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
                <Box display="flex" alignItems="center">
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#353535' }}>
                        {title}
                    </Typography>
                    {tooltipText && (
                        <Tooltip title={tooltipText} placement="right" arrow>
                            <HelpOutlineIcon style={{ fontSize: 16, color: '#999', marginLeft: 6, cursor: 'pointer' }} />
                        </Tooltip>
                    )}
                </Box>
            </Box>
            <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} style={{ flexBasis: '80%', maxWidth: '80%' }}>
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </Grid>
                <Grid item xs={12} style={{ flexBasis: '20%', maxWidth: '20%' }}>
                    <Box style={{
                        backgroundColor: '#f7f9fc',
                        borderRadius: 10,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                        border: '1px solid #e8ecf1',
                        padding: '12px 8px',
                    }}>
                        {helpText && (
                            <Typography variant="body2" align="center" style={{ color: helpTextColor || avgColor, fontSize: 13, fontWeight: 700, marginBottom: 8 }}>
                                {helpText}
                            </Typography>
                        )}
                        <Box display="flex" justifyContent="space-around" textAlign="center">
                            <Box style={{ flex: 1 }}>
                                <Box display="flex" alignItems="baseline" justifyContent="center">
                                    <Typography variant="h3" style={{ fontWeight: 700, color: avgColor, lineHeight: 1.1 }}>
                                        {avg}
                                    </Typography>
                                    {unit && (
                                        <Typography variant="caption" style={{ color: avgColor, fontSize: 11, fontWeight: 500, marginLeft: 3 }}>
                                            {unit}
                                        </Typography>
                                    )}
                                </Box>
                                <Typography variant="caption" display="block" style={{ color: '#888', fontSize: 11, marginTop: 4, fontWeight: 500 }}>
                                    Promedio
                                </Typography>
                            </Box>
                            <Box style={{ width: 1, backgroundColor: '#e0e0e0', alignSelf: 'stretch' }} />
                            <Box style={{ flex: 1 }}>
                                <Box display="flex" alignItems="baseline" justifyContent="center">
                                    <Typography variant="h3" style={{ fontWeight: 700, color: p95Color, lineHeight: 1.1 }}>
                                        {p95}
                                    </Typography>
                                    {unit && (
                                        <Typography variant="caption" style={{ color: p95Color, fontSize: 11, fontWeight: 500, marginLeft: 3 }}>
                                            {unit}
                                        </Typography>
                                    )}
                                </Box>
                                <Typography variant="caption" display="block" style={{ color: '#888', fontSize: 11, marginTop: 4, fontWeight: 500 }}>
                                    P95
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
